import classes from './BlockingLayer.module.scss'

export const BlockingLayer: React.FC = () => {
  return <div className={classes.blockingLayerRoot} data-testid="blockingLayer" />
}

export default BlockingLayer
